import { Typography } from "@material-ui/core";
import React from "react";
import { Zoom, } from "react-reveal";
import { useData } from "../../context/DataContext";
import Head from "../Head";
import Collapseable from "../utils/Collapseable";

const FAQ = () => {
  const { faq } = useData();

  return (
    <div className="container faq py-5">
      <Head title="FAQ" />
      <Typography variant="h1">FAQ</Typography>
        {faq.data?.map((el,i)=> <Collapseable name="question" desc="answer" key={i} i={i} {...el}  />)}
      <Zoom>
      </Zoom>
    </div>
  );
};

export default FAQ;
